<p-dialog [(visible)]="display" [modal]="true" [style]="{width: '90vw'}" [blockScroll]="true"
          class="no-padding-footer fixed-header no-padding-bottom no-scroll no-padding" [closable]="false">
    <ng-template pTemplate="header">
        <div class="p-grid">
            <div class="p-col-3 p-pb-0" *ngIf="!isonlyMsg">
                <div class="p-d-flex p-jc-between p-pt-3">
                    <h5 class="p-mb-2 p-ml-2">Chats</h5>
                    <div class="p-input-icon-left w-100 p-ml-3" style="margin-top:-0.25rem">
                        <i class="pi pi-search"></i>
                        <input type="text" [(ngModel)]="searchContacts" (ngModelChange)="onSearchChange($event)" pInputText placeholder="Search" />
                    </div>
                </div>
            </div>
            <div class="p-pb-0" [ngClass]="isonlyMsg ? 'p-col-12' : 'p-col-9'">
                <div class="contact-profile w-100 p-pt-2 p-pb-1 p-d-flex p-jc-between">
                    <div style="flex-grow: 1;" class="p-d-flex" *ngIf="state == 'direct'">
                        <ng-container *ngIf="activeUser">
                            <div class="initial-container relative" *ngIf="activeUser.image == '' || activeUser.image == null">
                                <span>{{getShortName(activeUser.name)}}</span>
                            </div>
                            <div>
                                <h5 class="p-mb-0">
                                    {{ activeUser.name }}
                                </h5>
                                <p>
                                    <span>{{selectedPhone?.phone}}</span>
                                    <span *ngIf="activeUser?.name == 'Unknown'" style="cursor: pointer;padding-left: 10px;" (click)="addContact()"><i class="pi pi-pencil"></i></span>
                                    <span class="btnBars" (click)="phonePanel.toggle($event)"
                                          *ngIf="activeUser?.phone.length>1">
                                        <i class="pi pi-angle-down"></i>
                                    </span>
                                </p>
                            </div>
                        </ng-container>
                    </div>
                    <div style="flex-grow: 1;" class="p-d-flex" *ngIf="state == 'group'">
                        <ng-container *ngIf="activeGroup">
                            <div class="image-container relative p-mr-3" *ngIf="activeGroup.image">
                                <img [src]="assestBaseUrl + 'images/' + activeGroup.image"  [alt]="activeGroup.name" class="product-image" />
                            </div>
                            <div class="initial-container relative" *ngIf="activeGroup.image == '' || activeGroup.image == null">
                                <span>{{getShortName(activeGroup.name)}}</span>
                            </div>
                            <h5 class="p-mb-0 p-mt-2">{{activeGroup.name}}</h5>
                        </ng-container>
                    </div>
                    <div class="p-d-flex">
                        <div>
                            <h5 class="p-mb-0 p-mr-2">{{loggedUser.name}}</h5>
                            <p>
                                <span>{{loggedUser?.phone}}</span>
                                <!--<span class="btnBars" (click)="loggedPanel.toggle($event)"
                                      *ngIf="loggedUser.phone.length > 1">
                                    <i class="pi pi-angle-down"></i>
                                </span>-->
                            </p>
                        </div>
                        <button pButton pRipple (click)="cancel()"
                                class="p-button-text p-button-rounded p-pt-0 p-mt-1" icon="pi pi-times"></button>
                    </div>
                </div>
                <p-overlayPanel #phonePanel [style]="{width: '200px'}" styleClass="no-padding">
                    <ng-template pTemplate>
                        <p-table [value]="activeUser?.phone" selectionMode="single" [(selection)]="selectedPhone"
                                 (onRowSelect)="onRowSelectPhone($event)">
                            <ng-template pTemplate="body" let-rowData let-product>
                                <tr [pSelectableRow]="rowData">
                                    <td>{{product.phone}}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </ng-template>
                </p-overlayPanel>
                <p-overlayPanel #loggedPanel [style]="{width: '200px'}" styleClass="no-padding">
                    <ng-template pTemplate>
                        <p-table [value]="loggedUser?.phone" selectionMode="single" [(selection)]="selectedLogged"
                                 (onRowSelect)="onRowSelectLogged($event)">
                            <ng-template pTemplate="body" let-rowData let-product>
                                <tr [pSelectableRow]="rowData">
                                    <td>{{product.phone}}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </ng-template>
                </p-overlayPanel>
            </div>
        </div>
    </ng-template>

    <div class="p-grid p-m-0">
        <div class="p-col-3 p-p-0" *ngIf="!isonlyMsg">
            <div class="left-panel">
                <div class="w-100">

                </div>

                <ul class="chats p-p-0 p-my-0" *ngIf="state == 'direct'">
                    <ng-container *ngFor="let product of chats;index as i">
                        <li [class.active]="selectedIndex === i" (click)="setIndex(i,product)">
                            <div class="image-container relative p-mr-3" *ngIf="product.image">
                                <img [src]="assestBaseUrl + 'images/' + product.image"  [alt]="product.name" class="product-image" />
                                <span class="online" [ngStyle]="{'background-color': (!product.expired || !product.subscribed) ? '#88d316' : '#ddd'}"></span>
                            </div>
                            <div class="initial-container relative" *ngIf="product.image == '' || product.image == null">
                                <span>{{getShortName(product.name)}}</span>
                                <span class="online" [ngStyle]="{'background-color': (!product.expired || !product.subscribed) ? '#88d316' : '#ddd'}"></span>
                            </div>
                            <div class="product-list-detail">
                                <h6 class="p-mb-0 accountName">{{product.name}}</h6>
                                <div class="accountName">{{product.moduleRecordName}}</div>
                                <ng-container *ngIf="product.lastMessage?.type ==='text'">
                                    <div style="word-break: break-all;">
                                        {{ product.lastMessage.reply ? product.lastMessage?.reply : product.lastMessage.text | slice:0:50 }}
                                    </div>
                                </ng-container>
                            </div>
                            <div class="product-list-action">
                                <div>{{getLatestDate(product)}}</div>
                                <p-badge [value]="product.unreadMessageCount" *ngIf="product.unreadMessageCount > 0" severity="info"></p-badge>
                                <span *ngIf="product?.lastMessage?.status && product.unreadMessageCount <= 0" class="p-mt-1">
                                    <i class="pi pi-check" *ngIf="product?.lastMessage?.status == 'sent'" pTooltip="Message sent" tooltipPosition="top"></i>
                                    <i class="pi pi-eye" *ngIf="product?.lastMessage?.status == 'read'" pTooltip="Message has been read" tooltipPosition="top"></i>
                                    <i class="pi pi-times-circle" style="color:red" *ngIf="product?.lastMessage?.status == 'failed'" pTooltip="Message failed to send" tooltipPosition="top"></i>
                                </span>
                            </div>
                        </li>
                    </ng-container>
                </ul>

                <ul class="chats p-p-0 p-my-0" *ngIf="state == 'group'">
                    <ng-container *ngFor="let product of groups;index as i">
                        <li [class.active]="selectedIndex === i" (click)="setIndex(i,product)">
                            <div class="image-container relative p-mr-3" *ngIf="product.image">
                                <img [src]="assestBaseUrl + 'images/' + product.image"  [alt]="product.name" class="product-image" />
                            </div>
                            <div class="initial-container relative" *ngIf="product.image == '' || product.image == null">
                                <span class="fa fa-users"></span>
                            </div>
                            <div class="product-list-detail">
                                <h6 class="p-mb-0 accountName">{{product.name}}</h6>
                            </div>
                            <div class="product-list-action">
                                <div class="mb-1">{{getLatestDate(product)}}</div>
                                <span class="pi pi-check" *ngIf="product.status == 'read'" style="color: #88d316;font-weight: bold;"></span>
                                <p-badge [value]="2" *ngIf="product.status == 'unread'" severity="info"></p-badge>
                                <span class="pi pi-exclamation-circle" style="color: red;" *ngIf="product.status == 'error'"></span>
                            </div>
                        </li>
                    </ng-container>
                </ul>
            </div>
        </div>

        <div class="p-p-0" [ngClass]="isonlyMsg ? 'p-col-12' : 'p-col-9'">
            <div class="right-panel w-100" #scrollMe
                 [ngStyle]="{'background-color': isSMS ? 'lavenderblush' : 'aliceblue' }">
                <div class="messages">
                    <ul class="p-p-2 p-m-0" *ngIf="state == 'direct'" id="box">
                        <ng-container *ngFor="let msg of whatsAppMessagesList;let i=index;">
                            <div class="p-text-center" *ngIf="i  && isDifferentDay(i)">
                                <p-divider align="center" type="dashed" class="date-divider">
                                    <span *ngIf="isToday(i) && isSameYear(i)">Today</span>
                                    <span *ngIf="isYesterday(i) && isSameYear(i)">Yesterday</span>
                                    <span *ngIf="isSameYear(i) && !isToday(i) && !isYesterday(i)">{{msg.time | localDate:'dddd, MM/DD/YYYY'}}</span>
                                    <span *ngIf="!isSameYear(i)">{{msg.time | localDate:'dddd, MM/DD/YYYY'}}</span>
                                </p-divider>
                            </div>

                            <li [id]="msg?.whatsAppMessageId" [ngClass]="{'cursor-pointer': msg?.messageContextId}"  [class]="msg.type">
                                <ng-container *ngIf="activeUser.image">
                                    <app-name-avatar
                                        *ngIf="msg.isExternal"
                                        [name]="activeUser.name"
                                        [bgHaxColor]="msg.avatarColorCode">
                                    </app-name-avatar>
                                    <app-name-avatar
                                        *ngIf="!msg.isExternal"
                                        [name]="msg?.senderName ?? ''"
                                        [bgHaxColor]="msg.avatarColorCode">
                                    </app-name-avatar>
                                </ng-container>
                                <ng-container *ngIf="activeUser.image == '' || activeUser.image == null">
                                    <ng-container *ngIf="msg.type === 'sent'">
                                        <div class="initial-container">
                                            <span>{{getShortName(loggedUser.name)}}</span>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="msg.type === 'receive'">
                                        <div class="initial-container">
                                            <span>{{getShortName(activeUser.name)}}</span>
                                        </div>
                                    </ng-container>
                                </ng-container>

                                <div style="flex-grow: 1;" class="p-px-2">
                                    <div class="p-d-flex user-container p-p-1" *ngIf="msg.type === 'receive'">
                                        <div><b>{{msg.senderName}}</b></div>
                                        <div class="p-mx-3">{{msg.time | localDate:'h:mm a'}}</div>
                                    </div>
                                    <div class="p-d-flex user-container p-p-1" *ngIf="msg.type === 'sent'">
                                        <span *ngIf="msg?.deliveryStatus">
                                            <!-- <i class="fa fa-check" style="color: #888;"
                                            *ngIf="msg?.deliveryStatus == 'sent'"></i> -->
                                            <i class="fa fa-check-square-o" style="color: #888;"
                                               *ngIf="msg?.deliveryStatus == 'delivered' || msg?.deliveryStatus == 'sent'"></i>
                                            <i class="fa fa-check-square-o" style="color: #88d316;"
                                               *ngIf="msg?.deliveryStatus == 'read'"></i>
                                            <i class="fa fa-clock-o" *ngIf="msg?.deliveryStatus == 'pending'"></i>
                                            <i class="fa fa-exclamation-circle"
                                               style="color:red;cursor: pointer;"
                                               *ngIf="msg?.deliveryStatus == 'failed'"
                                               [pTooltip]="msg?.deliveryMessage ?? ''"
                                               tooltipPosition="left"></i>
                                        </span>
                                        <div class="p-mx-3">{{msg.time | localDate:'h:mm a'}}</div>
                                        <!-- *ngIf="!msg.replyMsg" -->
                                        <div *ngIf="!msg.replyMsg"><b>{{msg.senderName}}</b></div>

                                    </div>
                                    <div [class.p-d-flex] = "msg.type === 'receive'" #smile
                                    (mouseenter) ="isShowMenu[i]=true" (mouseleave) ="isShowMenu[i] = false;">

                                        <p class="p-mb-2" style="position: relative;" [class.img-center] = "msg.messageType === 'image' || msg.messageType === 'audio' || msg.messageType === 'video'">
                                            <ng-container *ngIf="msg?.replyMsg">
                                                    <div class="reply-msg" (click)="removeOutline();openScroll(msg)">
                                                        <div style="color: #000;" class="p-mb-1"><b>{{msg?.receiverName}}</b></div>
                                                        <div >
                                                            <span *ngIf="msg?.contextType == 'text'" style="color: #777;">{{msg?.message}}</span>
                                                            <span *ngIf="msg?.contextType == 'button'" style="color: #777;">{{msg?.message}}</span>
                                                            <img src="{{ msg?.message?.BlobFileLink }}" alt="Image" style="height: 30px;float: none;"
                                                            *ngIf="msg?.contextType == 'image'" />
                                                            <audio controls height="30" *ngIf="msg?.contextType == 'audio'" controlsList="nodownload noplaybackrate">
                                                                <source src="{{ msg?.message?.BlobFileLink }}" type="{{ msg?.message?.MimeType }}">
                                                            </audio>
                                                            <video controls height="30" *ngIf="msg?.contextType == 'video'">
                                                                <source src="{{ msg?.message?.BlobFileLink }}" type="{{ msg?.message?.MimeType }}">
                                                            </video>
                                                            <a style="font-size: 14px;" *ngIf="msg?.contextType == 'document'">
                                                                <span><i class="pi pi-file"></i></span>
                                                                {{ msg?.message?.FileName }}
                                                            </a>
                                                            <div *ngIf="msg?.contextType == 'template'">
                                                                <div style="display: flex;">
                                                                    <div>
                                                                        <audio controls height="30" *ngIf="msg?.originalMessageContext?.blobFileLink && msg?.originalMessageContext?.contextMediaType == 'audio'"
                                                                        controlsList="nodownload noplaybackrate">
                                                                            <source src="{{ msg?.originalMessageContext?.blobFileLink }}" type="{{ msg?.message?.MimeType }}">
                                                                        </audio>
                                                                        <video *ngIf="msg?.originalMessageContext?.blobFileLink && msg?.originalMessageContext?.contextMediaType == 'video'" controls height="30" >
                                                                            <source src="{{ msg?.originalMessageContext?.blobFileLink }}" type="{{ msg?.message?.MimeType }}">
                                                                        </video>
                                                                         <img *ngIf="msg?.originalMessageContext?.blobFileLink && msg?.originalMessageContext?.contextMediaType == 'image'" src="{{ msg?.originalMessageContext?.blobFileLink }}" alt="Image" style="height: 30px;"/>
                                                                         <a style="font-size: 14px;" *ngIf="msg?.originalMessageContext?.blobFileLink && msg?.originalMessageContext?.contextMediaType  == 'document'">
                                                                            <span><i class="pi pi-file"></i></span>
                                                                            {{ msg?.message?.FileName }}
                                                                        </a>
                                                                    </div>
                                                                    <div>
                                                                        <span style="color: #777;">{{msg?.originalMessageContext?.text}}</span>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            <div *ngIf="msg?.contextType == 'interactive'">
                                                                <div style="word-break: break-all;white-space: pre-wrap;">{{msg?.message?.header?.text}}</div>
                                                                <div style="word-break: break-all;white-space: pre-wrap;">{{msg?.message?.body?.text}}</div>
                                                                <div style="word-break: break-all;white-space: pre-wrap;">{{msg?.message?.footer?.text}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                            </ng-container>
                                            <ng-container *ngIf="msg.messageType === 'text'">
                                                <span *ngIf="!msg?.replyMsg" [ngStyle]="{'color':(msg.message == 'Deny') ? 'red' : ((msg.message == 'Accept') ? '#88d316' : null)}"
                                                style="word-break: break-all;white-space: pre-wrap;">
                                                    {{msg?.message || ''}}
                                                </span>
                                                <span *ngIf="msg?.replyMsg"  [ngStyle]="{'color':(msg.message == 'Deny') ? 'red' : ((msg.message == 'Accept') ? '#88d316' : null)}">
                                                    {{msg?.replyMsg || ''}}
                                                </span>
                                                <span class="reaction-emoji" *ngIf="msg?.reaction">{{msg?.reaction}}</span>
                                                <!-- *ngIf="msg.type === 'receive'" -->
                                                <span  class="pi pi-angle-down cursor-pointer reply-menu-icon" (click)="replymenu.toggle($event);getMsgValue(msg)"></span>
                                            </ng-container>

                                            <ng-container *ngIf="msg.messageType === 'interactive'">

                                                <div *ngIf="!msg?.replyMsg" style="min-width: 300px;">
                                                    <div>{{msg?.message?.header?.text}}</div>
                                                    <div>{{msg?.message?.body?.text}}</div>
                                                    <div>{{msg?.message?.footer?.text}}</div>
                                                    <p-card styleClass="msg-action-button">
                                                        <div class="p-text-center" style="color: #4c9edc;">
                                                            <span class="fa fa-external-link p-mr-2"></span>
                                                            <span pTooltip="{{ msg?.message?.action?.parameters?.flow_cta }}" tooltipPosition="bottom">{{ msg?.message?.action?.parameters?.flow_cta }}</span>
                                                        </div>
                                                    </p-card>
                                                </div>

                                                <div *ngIf="msg?.replyMsg">
                                                    <!-- <div *ngFor="let item of getObjectKeys(msg?.replyMsg)">
                                                        <div *ngIf="item != 'flow_token'"><b>{{ item }}:</b> {{ msg?.replyMsg[item] }}</div>
                                                      </div> -->

                                                      <div *ngFor="let item of msg?.replyMsg?.list[0].response">
                                                        <div><b>{{ item?.field || item?.Field }}:</b> {{ item?.value || item.Value}}</div>
                                                      </div>
                                                </div>
                                                <!-- <span class="pi pi-angle-down cursor-pointer reply-menu-icon" *ngIf="isShowMenu[i]"
                                                (click)="replymenu.toggle($event);getMsgValue(msg)"></span> -->

                                            </ng-container>

                                            <ng-container *ngIf="msg.messageType === 'template'">
                                                <div class="p-d-flex p-flex-nowrap" [ngClass]="{' p-flex-column': msg.message.header || msg.message.footer}">
                                                    <div class="msg-footer" *ngIf='msg.message.header'>{{msg.message.header.text}}</div>
                                                    <ng-container [ngSwitch]="msg.message.payload?.header?.type">
                                                        <ng-container *ngSwitchCase="'video'">
                                                            <video controls width="230" height="auto">
                                                                <source src="{{ msg.message.payload.header?.link }}">
                                                                Your browser does not support the video element.
                                                            </video>
                                                        </ng-container>
                                                        <ng-container *ngSwitchCase="'image'">
                                                            <img (click)="openImg({ link: msg.message.payload.header?.link, caption: ''})"
                                                                 src="{{msg.message.payload.header.link}}" alt="Template Image"
                                                                 class="cursor-pointer"
                                                                 style="width: 200px; height: auto; border-radius: 8px" />
                                                        </ng-container>
                                                        <ng-container *ngSwitchCase="'document'">
                                                            <a href="{{ msg.message.payload.header.link }}" target="_blank" style="font-size: 14px;">
                                                                <span><i class="pi pi-file"></i></span>
                                                                 Document
                                                            </a>
                                                        </ng-container>
                                                    </ng-container>
                                                    <span class="pi pi-angle-down cursor-pointer reply-menu-icon" *ngIf="isShowMenu[i]"
                                                        (click)="replymenu.toggle($event);getMsgValue(msg)"></span>
                                                    <div class="msg-body" style="word-break: break-all;white-space: pre-wrap;" *ngIf='msg.message.body'>{{formatMsgBody(msg.message)}}</div>
                                                    <span class="reaction-emoji" *ngIf="msg?.reaction">{{msg?.reaction}}</span>

                                                    <div class="msg-footer" *ngIf='msg.message.footer'>{{msg.message.footer}}</div>
                                                </div>
                                            </ng-container>

                                            <ng-container *ngIf="msg.messageType === 'image'">
                                                <div *ngIf="!msg?.replyMsg" class="p-d-flex p-flex-column"  style="min-height: 100px">
                                                    <img src="{{ msg?.message?.BlobFileLink }}" alt="Image" class="cursor-pointer"
                                                         style="width: 200px; height: auto; border-radius: 0;"
                                                         (click)="openImg({ link: msg?.message?.BlobFileLink, caption: msg?.message?.Caption})" />
                                                    <p class="no-border" *ngIf="msg?.message?.Caption">{{ msg?.message?.Caption }}</p>
                                                    <span class="reaction-emoji" *ngIf="msg?.reaction">{{msg?.reaction}}</span>
                                                    <span class="pi pi-angle-down cursor-pointer reply-menu-icon" *ngIf="isShowMenu[i]"
                                                    (click)="replymenu.toggle($event);getMsgValue(msg)"></span>
                                                </div>
                                                <div *ngIf="msg?.replyMsg" class="p-d-flex p-flex-column"  style="min-height: 100px">
                                                    <img src="{{ msg?.replyMsg?.BlobFileLink }}" alt="Image" class="cursor-pointer"
                                                         style="width: 200px; height: auto; border-radius: 0;"
                                                         (click)="openImg({ link: msg?.replyMsg?.BlobFileLink, caption: msg?.replyMsg?.Caption})" />
                                                    <p class="no-border" *ngIf="msg?.replyMsg?.Caption">{{ msg?.replyMsg?.Caption }}</p>
                                                    <span class="reaction-emoji" *ngIf="msg?.reaction">{{msg?.reaction}}</span>
                                                    <span class="pi pi-angle-down cursor-pointer reply-menu-icon" *ngIf="isShowMenu[i]"
                                                    (click)="replymenu.toggle($event);getMsgValue(msg)"></span>
                                                </div>
                                            </ng-container>

                                            <ng-container *ngIf="msg.messageType === 'button'">
                                                <span *ngIf="!msg?.replyMsg" [ngStyle]="{'color':(msg.message == 'Deny') ? 'red' : ((msg.message == 'Accept') ? '#88d316' : null)}"
                                                style="word-break: break-all;white-space: pre-wrap;">
                                                    {{msg?.message || ''}}
                                                </span>
                                                <span *ngIf="msg?.replyMsg" [ngStyle]="{'color':(msg.message == 'Deny') ? 'red' : ((msg.message == 'Accept') ? '#88d316' : null)}">
                                                    {{msg?.replyMsg || ''}}
                                                </span>
                                                <span class="reaction-emoji" *ngIf="msg?.reaction">{{msg?.reaction}}</span>
                                                <span class="pi pi-angle-down cursor-pointer reply-menu-icon" *ngIf="isShowMenu[i]"
                                                (click)="replymenu.toggle($event);getMsgValue(msg)"></span>
                                            </ng-container>

                                            <ng-container *ngIf="msg.messageType === 'audio'">
                                                    <audio *ngIf="!msg?.replyMsg" controls controlsList="nodownload noplaybackrate">
                                                        <source src="{{ msg?.message?.BlobFileLink }}" type="{{ msg?.message?.MimeType }}">
                                                        Your browser does not support the audio element.
                                                    </audio>
                                                    <audio *ngIf="msg?.replyMsg" controls controlsList="nodownload noplaybackrate">
                                                        <source src="{{ msg?.replyMsg?.BlobFileLink }}" type="{{ msg?.message?.MimeType }}">
                                                        Your browser does not support the audio element.
                                                    </audio>
                                                    <span class="reaction-emoji" *ngIf="msg?.reaction">{{msg?.reaction}}</span>
                                                    <span class="pi pi-angle-down cursor-pointer reply-menu-icon" *ngIf="isShowMenu[i]"
                                                    (click)="replymenu.toggle($event);getMsgValue(msg)"></span>
                                            </ng-container>

                                            <ng-container *ngIf="msg.messageType === 'video'">
                                                <ng-container *ngIf="!msg?.replyMsg">
                                                    <video  controls width="230" height="auto">
                                                        <source src="{{ msg?.message?.BlobFileLink }}" type="{{ msg?.message?.MimeType }}">
                                                        Your browser does not support the video element.
                                                    </video>
                                                    <p class="no-border" *ngIf="msg?.message?.Caption">{{ msg?.message?.Caption }}</p>
                                                </ng-container>
                                                <ng-container *ngIf="msg?.replyMsg">
                                                    <video *ngIf="msg?.replyMsg" controls width="230" height="auto">
                                                        <source src="{{ msg?.replyMsg?.BlobFileLink }}" type="{{ msg?.message?.MimeType }}">
                                                        Your browser does not support the video element.
                                                    </video>
                                                    <p class="no-border" *ngIf="msg?.replyMsg?.Caption">{{ msg?.replyMsg?.Caption }}</p>
                                                </ng-container>
                                                    <span class="reaction-emoji" *ngIf="msg?.reaction">{{msg?.reaction}}</span>
                                                    <span class="pi pi-angle-down cursor-pointer reply-menu-icon" *ngIf="isShowMenu[i]"
                                                    (click)="replymenu.toggle($event);getMsgValue(msg)"></span>
                                            </ng-container>

                                            <ng-container *ngIf="msg.messageType === 'document'">
                                                <a *ngIf="!msg?.replyMsg" href="{{ msg?.message?.BlobFileLink}}" style="font-size: 14px;">
                                                    <span><i class="pi pi-download"></i></span>
                                                    {{ msg?.message?.FileName }}
                                                </a>
                                                <a *ngIf="msg?.replyMsg" href="{{ msg?.replyMsg?.BlobFileLink}}" style="font-size: 14px;">
                                                    <span><i class="pi pi-download"></i></span>
                                                    {{ msg?.replyMsg?.FileName }}
                                                </a>
                                                <span class="reaction-emoji" *ngIf="msg?.reaction">{{msg?.reaction}}</span>
                                                <span class="pi pi-angle-down cursor-pointer reply-menu-icon" *ngIf="isShowMenu[i]"
                                                (click)="replymenu.toggle($event);getMsgValue(msg)"></span>
                                            </ng-container>

                                            <!-- Reply to message -->
                                            <!--<span *ngIf="msg.type === 'receive'"
                                                  pTooltip="Reply message."
                                                  (click)="replyMessage(msg)"
                                                  class="cursor-pointer p-ml-2">
                                                 <i class="pi pi-reply"></i>
                                            </span>-->

                                            <!-- Resend message -->
                                            <span *ngIf="msg?.deliveryStatus === 'failed' && msg.type === 'sent'"
                                                  pTooltip="Resend message."
                                                  (click)="resendMessage(msg)"
                                                  [ngClass]="{'p-ml-2': msg.messageType === 'text', 'p-mt-3': msg.messageType !== 'text'}"
                                                  class="cursor-pointer">
                                                <i class="pi pi-refresh"></i>
                                            </span>

                                            <p-overlayPanel #emojiMenu [style]="{width: '200px'}" styleClass="emoji-panel">
                                                <ng-template pTemplate>
                                                    <div class="p-grid">
                                                        <div class="p-col cursor-pointer" *ngFor="let s of emojis">
                                                            <span (click)="reactionMsg(s,msg);emojiMenu.hide()">{{s.emoji}}</span>
                                                        </div>
                                                    </div>
                                                </ng-template>
                                            </p-overlayPanel>
                                        </p>

                                        <ng-container *ngIf="msg?.message?.buttons?.length>0">
                                            <div class="msg-action-button-wrapper">
                                                <ng-container *ngFor="let s of msg?.message?.buttons;">
                                                    <div class="p-mt-1" *ngIf="s.text !== '' && s.text !== null && s.text !== undefined">
                                                        <p-card styleClass="msg-action-button">
                                                            <div class="p-text-center" style="color: #4c9edc;">
                                                                <span class="fa fa-phone p-mr-2" *ngIf="s.type === 'PHONE_NUMBER'"></span>
                                                                <span class="fa fa-external-link p-mr-2" *ngIf="s.type === 'URL'"></span>
                                                                <span pTooltip="{{ s.text }}" tooltipPosition="bottom">{{ s.text }}</span>
                                                            </div>
                                                        </p-card>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </ng-container>

                                        <span class="p-ml-2 p-mt-1 cursor-pointer" *ngIf="msg.type === 'receive' && isShowMenu[i]"
                                        style="font-size: 20px;color: var(--primary-color);">
                                            <i class="fa fa-smile-o" (click)="emojiMenu.toggle($event);"></i>
                                        </span>
                                    </div>

                                    <!-- --------reply and reset -->

                                    <p-overlayPanel #replymenu [style]="{width: '150px'}" styleClass="no-padding">
                                        <ng-template pTemplate>
                                            <p-listbox
                                                [options]="menus"
                                                [(ngModel)]="selectedReplyMenu"
                                                optionLabel="name"
                                                [style]="{'width':'15rem', 'border': 'none'}"
                                                (onChange)="changeReplyMenu($event,msg);replymenu.hide();">
                                            </p-listbox>
                                        </ng-template>
                                    </p-overlayPanel>


                                    <p-divider align="center" type="dashed" class="deny-seperator" *ngIf="msg?.message == 'Deny'">
                                        <b>Deny</b>
                                    </p-divider>
                                    <p-divider align="center" type="dashed" class="accept-seperator" *ngIf="msg?.message == 'Accept'">
                                        <b>Accept</b>
                                    </p-divider>
                                </div>

                            </li>

                        </ng-container>

                        <!-- Preview reply msg-->
                        <ng-container *ngIf="selectedReplyMsg">
                            <div class="p-text-right" style="background-color: #fff">
                                <div>{{ selectedReplyMsg?.senderName }}</div>
                                <div>{{ selectedReplyMsg?.message }}</div>
                            </div>
                        </ng-container>
                    </ul>

                    <ul class="p-p-2 p-m-0" *ngIf="state == 'group'">
                        <ng-container *ngFor="let msg of activeGroup?.messages;let i=index;">
                            <div class="p-text-center" *ngIf="isDifferentDay(i)">
                                <p-divider align="center" type="dashed" class="date-divider">
                                    <span *ngIf="isToday(i) && isSameYear(i)">Today</span>
                                    <span *ngIf="isYesterday(i) && isSameYear(i)">Yesterday</span>
                                    <span *ngIf="isSameYear(i) && !isToday(i) && !isYesterday(i)">{{msg.time | localDate:'dddd, MM/DD/YYYY'}}</span>
                                    <span *ngIf="!isSameYear(i)">{{msg.time | localDate:'dddd, MM/DD/YYYY'}}</span>
                                </p-divider>
                            </div>[src]="assestBaseUrl + 'images/' + product.image"
                            <li [class]="msg.type" class="p-my-1">
                                <ng-container *ngIf="msg.image">
                                    <img [src]="msg.type === 'sent' ? assestBaseUrl + 'images/' + loggedUser.image  : assestBaseUrl + 'images/' + msg.image" alt="" />
                                </ng-container>
                                <ng-container *ngIf="msg.image == '' || msg.image == null">
                                    <ng-container *ngIf="msg.type === 'sent'">
                                        <img  [src]="assestBaseUrl + 'images/' + loggedUser.image" [alt]="loggedUser.name" />
                                    </ng-container>
                                    <ng-container *ngIf="msg.type === 'receive'">
                                        <div class="initial-container">
                                            <span>{{getShortName(msg.name)}}</span>
                                        </div>
                                    </ng-container>
                                </ng-container>
                                <div style="flex-grow: 1;" class="p-px-2">
                                    <div class="p-d-flex user-container p-p-1">
                                        <div><b>{{msg.type === 'sent' ? loggedUser.name : msg.name}}</b></div>
                                        <div class="p-mx-3">{{msg.time | localDate:'h:mm a'}}</div>
                                    </div>
                                    <p>{{msg?.message || ''}}</p>
                                </div>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div>
        </div>

    </div>


    <ng-template pTemplate="footer">
        <div class="p-grid">
            <div class="p-col-3 paginate" *ngIf="!isonlyMsg">
                <p-paginator styleClass="child-paginator p-pb-0 p-pt-1" [first]="first" [rows]="pageSize" [totalRecords]="totalRows" (onPageChange)="onPageChange($event)" [showPageLinks]="true"></p-paginator>
            </div>
            <div class="p-pb-0" [ngClass]="isonlyMsg ? 'p-col-12' : 'p-col-9'">
                <div *ngIf="isReply" class="reply-box p-d-flex p-jc-between">
                    <div style="flex-grow: 1;">
                        <p style="color: #777;" class="small p-mb-1">{{tempMsg?.senderName}}</p>
                        <span style="color: #777;" *ngIf="tempMsg?.messageType == 'text' || tempMsg?.messageType == 'button'">
                            {{tempMsg?.replyMsg ? tempMsg?.replyMsg : tempMsg?.message}}
                        </span>
                        <img src="{{ tempMsg?.message?.BlobFileLink }}" alt="Image" style="height: 30px;"
                        *ngIf="tempMsg?.messageType == 'image'" />
                        <audio controls height="30" *ngIf="tempMsg?.messageType == 'audio'"
                        controlsList="nodownload noplaybackrate">
                            <source src="{{ tempMsg?.message?.BlobFileLink }}" type="{{ tempMsg?.message?.MimeType }}">
                        </audio>
                        <video controls height="30" *ngIf="tempMsg?.messageType == 'video'">
                            <source src="{{ tempMsg?.message?.BlobFileLink }}" type="{{ tempMsg?.message?.MimeType }}">
                        </video>
                        <a style="font-size: 14px;" *ngIf="tempMsg?.messageType == 'document'">
                            <span><i class="pi pi-file"></i></span>
                            {{ tempMsg?.message?.FileName }}
                        </a>
                        <span style="color: #777;" *ngIf="tempMsg?.messageType == 'template'">
                            {{tempMsg?.message?.body}}
                        </span>
                    </div>
                    <span class="btnBars" (click)="removeReply()">
                        <i class="pi pi-times"></i>
                    </span>
                </div>
                <div class="message-input">
                    <div class="p-inputgroup">
                        <button [disabled]="(this.selectedConversation?.expired || !this.selectedConversation?.subscribed) || expiredSubscriptionData?.statusId == 2" type="button" pButton pRipple (click)="emojiPanel.toggle($event)"
                        class="largeIcon">
                            <span style="font-size:18px" tooltipPosition="top" pTooltip="Select Emoji">😀</span>
                        </button>

                        <button [disabled]="expiredSubscriptionData?.statusId == 2" type="button" pButton (click)="chatmenu.toggle($event)" class="largeIcon"
                        icon="pi pi-plus" style="margin-left: 0.05rem">
                        </button>

                        <div style="position: relative;flex-grow:1;" *ngIf="!isRecording && !blobUrl">
                            <textarea rows="2" pInputTextarea autoResize="autoResize" #msgInput
                            [disabled]="(this.selectedConversation?.expired || !this.selectedConversation?.subscribed) || expiredSubscriptionData?.statusId == 2"
                            placeholder="Write your message..." [(ngModel)]="chatInputMessage"
                            (keydown.enter)="$event.preventDefault();handleEnterKey($event,msgInput)" maxlength="1024" style="border:none"></textarea>
                            <span style="position: absolute;right: 2px;bottom: 3px;">{{chatInputMessage.length}}/1024</span>
                        </div>

                        <div class="p-p-3" style="flex-grow:1;background:#f0f0f0" *ngIf="isRecording && !blobUrl"> {{recordedTime}} </div>
                        <div style="flex-grow:1;background:#f0f0f0" *ngIf="!isRecording && blobUrl">
                            <audio controls controlsList="nodownload noplaybackrate">
                                <source [src]="blobUrl" type="audio/mp3">
                            </audio>
                        </div>
                        <button type="button" pButton pRipple *ngIf="!isRecording && blobUrl"
                        (click)="clearRecordedData()" icon="pi pi-trash" class="largeIcon p-button-danger"
                        pTooltip="Delete Record" tooltipPosition="top" [disabled]="expiredSubscriptionData?.statusId == 2"></button>

                        <button type="button" pButton pRipple icon="fa fa-microphone" class="largeIcon"
                        *ngIf="!isRecording && !blobUrl && chatInputMessage.length == 0" (click)="startRecording()"
                        pTooltip="Start Recording" tooltipPosition="top" [disabled]="expiredSubscriptionData?.statusId == 2"></button>

                        <button type="button" pButton pRipple *ngIf="isRecording && !blobUrl" class="largeIcon p-button-danger"
                        (click)="stopRecording()" icon="fa fa-stop-circle-o"
                        pTooltip="Stop Recording" tooltipPosition="top"></button>

                        <button type="button" pButton pRipple class="largeIcon"
                        *ngIf="chatInputMessage.length > 0 || (!isRecording && blobUrl) || expiredSubscriptionData?.statusId == 2"
                                icon="fa fa-paper-plane"
                                [disabled]="this.selectedConversation?.expired || !this.selectedConversation?.subscribed"
                                (click)="addNewMessage(msgInput)">
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <p-overlayPanel #emojiPanel class="no-padding" appendTo="body">
            <ng-template pTemplate>
                <emoji-mart #emoji
                            class="emoji-mart"
                            set="{{ set }}"
                            (emojiSelect)="addEmoji($event)"
                            title="Pick your emoji…"
                ></emoji-mart>
            </ng-template>
        </p-overlayPanel>
        <p-overlayPanel #templateMessage styleClass="no-padding">
            <p-listbox
                [options]="templateMessages"
                [(ngModel)]="selectedInboxTemplate"
                optionLabel="name"
                [style]="{'width':'15rem', 'border': 'none'}"
                [listStyle]="{'max-height': '220px'}"
                (onChange)="sentTemplateMessage($event);templateMessage.hide();">
            </p-listbox>
        </p-overlayPanel>
        <p-overlayPanel #flowList styleClass="no-padding">
            <p-listbox
                [options]="flowFormList"
                [(ngModel)]="selectedFlow"
                optionLabel="flowName"
                [style]="{'width':'15rem', 'border': 'none'}"
                [listStyle]="{'max-height': '220px'}"
                (onChange)="sentFlowMessage($event);"
               >
            </p-listbox>
        </p-overlayPanel>
        <p-overlayPanel #chatmenu styleClass="no-padding chat-panel" appendTo="body">
            <ul>
                <li>
                    <p-fileUpload
                        [disabled]="this.selectedConversation?.expired || !this.selectedConversation?.subscribed"
                        #fileUpload mode="basic" [customUpload]="true" name="attachment[]"
                        maxFileSize="maxFileSize" chooseLabel="Attachment"
                        chooseIcon="pi pi-paperclip" (onSelect)="openFiles()" [multiple]="true">
                    </p-fileUpload>
                </li>
                <li>
                    <button *ngIf="isWhatsapp" type="button" pButton (click)="templateMessage.toggle($event)"
                    icon="pi pi-comment" label="Template">
                    </button>
                </li>
                <li>
                    <button type="button" pButton icon="pi pi-align-justify" label="FLOW" (click)="flowList.toggle($event)"></button>
                </li>
                <!-- <li>
                    <button type="button" pButton icon="pi pi-camera" label="Camera"></button>
                </li> -->
            </ul>
        </p-overlayPanel>
    </ng-template>
</p-dialog>

<p-dialog header="Add Group" [(visible)]="displayGroup" [style]="{width: '60vw'}">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <label>Group Name</label>
                <input type="text" pInputText [(ngModel)]="tempGroup.name"
                       [ngClass]="{'ng-invalid ng-dirty': isRepeat}">
                <small id="username2-help" class="p-error block" *ngIf="isRepeat">Username is not available.</small>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-12">
                <label>Contacts</label>
                <p-multiSelect [options]="contacts" [(ngModel)]="selectedContacts" defaultLabel="Select a Contact"
                               optionLabel="name" selectedItemsLabel="{0} items selected" appendTo="body"></p-multiSelect>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-12">
                <label>Group Image</label>
                <p-fileUpload name="demo[]" url="./upload.php" (onUpload)="onUpload($event)"
                              multiple="multiple" accept="image/*" maxFileSize="1000000" [fileLimit]="1">
                    <ng-template pTemplate="content">
                        <ul *ngIf="uploadedFiles.length">
                            <li *ngFor="let file of uploadedFiles">{{file.name}} - {{file.size}} bytes</li>
                        </ul>
                    </ng-template>
                </p-fileUpload>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button type="button" pButton (click)="displayGroup=false" label="Cancel" class="p-button-secondary"></button>
        <button type="submit" pButton label="Save" (click)="isRepeatName(tempGroup.name)"></button>
    </ng-template>
</p-dialog>

<p-dialog header="" [(visible)]="displayImg" [style]="{width: '80vw'}">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12 p-text-center">
                <img src="{{ tempImg?.link }}" alt="Image" [style.height.px]="innerheight-300" />
                <h5 *ngIf="tempImg?.caption">{{ tempImg?.caption }}</h5>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button type="button" pButton (click)="displayImg=false" label="Cancel" class="p-button-secondary"></button>
    </ng-template>
</p-dialog>

<p-dialog header="" [(visible)]="displayFiles" [style]="{width: '70vw'}" (onHide)="clearSelectedMedia()">
    <div class="card">
        <p-carousel  [value]="uploadedFiles" [numVisible]="1" [numScroll]="1">
            <ng-template let-data pTemplate="item">
                <div class="p-grid">
                    <div class="p-col-6 p-offset-3 p-text-center">
                        <ng-container [ngSwitch]="data.type">
                            <ng-container *ngSwitchCase="'image'">
                                <img [src]="data?.file?.objectURL?.changingThisBreaksApplicationSecurity | sanitizeUrl"
                                     alt="Image" style="width: 100%;" />
                            </ng-container>
                            <ng-container *ngSwitchCase="'audio'">
                                <audio controls controlsList="nodownload noplaybackrate">
                                    <source [src]="data.objectUrl | sanitizeUrl" type="audio/mp3">
                                    <source [src]="data.objectUrl | sanitizeUrl" type="audio/ogg">
                                    <source [src]="data.objectUrl | sanitizeUrl" type="audio/mpeg">
                                    Your browser does not support the audio element.
                                </audio>
                            </ng-container>
                            <ng-container *ngSwitchCase="'video'">
                                <video style="width: 100%;" controls>
                                    <source [src]="data.objectUrl | sanitizeUrl" type="video/mp4">
                                    <source [src]="data.objectUrl | sanitizeUrl" type="video/webm">
                                    Your browser does not support the video tag.
                                </video>
                            </ng-container>
                            <ng-container *ngSwitchCase="'document'">
                                <div class="p-my-4">
                                    <span ><i class="pi pi-file" style="font-size: 2rem;"></i></span>
                                </div>
                            </ng-container>
                        </ng-container>
                        <h5 *ngIf="data?.file?.name">{{ data?.file?.name }}</h5>
                        <div class="p-d-flex" *ngIf="data.type === 'image' || data.type === 'video'">
                            <!-- <label class="p-mr-2">Caption: </label>-->
                            <textarea pInputTextarea rows="4" [(ngModel)]="data.caption" placeholder="Write Caption..."></textarea>
                        </div>
                    </div>
                </div>
            </ng-template>
        </p-carousel>
    </div>
    <ng-template pTemplate="footer">
        <button type="button" pButton (click)="cancelFile()" label="Cancel" class="p-button-secondary"></button>
        <button type="submit" pButton label="Send" (click)="sendFiles()"></button>
    </ng-template>
</p-dialog>

<app-add-edit-contacts-list (cancelClicked)='onCancelContact()' (contactCreated)='newContactCreate($event)'
    (contactTypeCreated)='getContactTypes($event)' *ngIf='displayAddEditContact'
    [contactHeader]='contactHeader'
    [selectedContactType]="this.selectedSubMenu" [selectedContact]="selectedContact"
    [display]='displayAddEditContact' [selectedPhone]="identifiedCountry">
</app-add-edit-contacts-list>

<app-edit-flow [display]="displayEditFlow" [selectedFlow]="selectedFlow" [callFromChat]="true" [isViewOnly]="false" (editFlowRequest)="submitFlowResponse($event)" (saveEditFlow)="onSaveEditFlow()"></app-edit-flow>
